import React from 'react';
import { WinMidDataImport } from '../components';

export default () => {
    return (

        <WinMidDataImport.Home />
    )
}